import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import ButtonWithFlyout from '../ButtonWithFlyout/ButtonWithFlyout.js';
import { Menu } from '../Menu/Menu.js';

var _excluded = ["children"];
var ButtonWithMenu = function ButtonWithMenu(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return (React__default.createElement(ButtonWithFlyout, props, React__default.createElement(Menu, null, children))
  );
};
ButtonWithMenu.propTypes = _objectSpread2({}, ButtonWithFlyout.propTypes);
var ButtonWithMenu$1 = ButtonWithMenu;

export { ButtonWithMenu$1 as default };
//# sourceMappingURL=ButtonWithMenu.js.map
